import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, User, ShoppingCart, LogIn } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { useCart } from "../../context/CartContext";
import { NotificationBell } from "../Shared";
import { HomeModeToggle } from "./HomeModeToggle";

// Header condiviso delle schermate Home Smart / pagine-lista.
// current: "smart" per la Home Smart, undefined nelle pagine-lista (mostra "indietro").
export default function SmartHeader({ current, back }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { count } = useCart();
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#0A0A0C]/80 border-b border-white/10 safe-top">
      <div className="max-w-6xl mx-auto px-3 sm:px-6 py-3 flex items-center justify-between gap-2 safe-px">
        <div className="flex items-center gap-2 min-w-0">
          {back && (
            <button data-testid="smart-back" onClick={() => navigate("/home")} className="p-2 -ml-1 rounded-full hover:bg-white/5 shrink-0">
              <ChevronLeft className="h-5 w-5" />
            </button>
          )}
          <button data-testid="smart-brand" onClick={() => navigate("/home")} className="font-display font-black text-base sm:text-lg text-[#00E676] tracking-tight truncate">
            Fuma c'anduma
          </button>
        </div>
        <div className="flex items-center gap-1.5 sm:gap-2 shrink-0">
          <HomeModeToggle current={current || "smart"} />
          {user ? (
            <>
              <NotificationBell />
              <button data-testid="smart-cart" onClick={() => navigate("/app/checkout")} className="relative p-2 rounded-full hover:bg-white/5">
                <ShoppingCart className="h-5 w-5" />
                {count > 0 && <span className="absolute -top-0.5 -right-0.5 bg-[#00E676] text-black text-[10px] font-bold rounded-full h-4 min-w-4 px-1 flex items-center justify-center">{count}</span>}
              </button>
              <button data-testid="smart-profile" onClick={() => navigate("/app/profile")} className="p-2 rounded-full hover:bg-white/5"><User className="h-5 w-5" /></button>
            </>
          ) : (
            <button data-testid="smart-login" onClick={() => navigate("/login")} className="flex items-center gap-1.5 rounded-full bg-[#00E676] text-black text-sm font-semibold px-3.5 py-1.5">
              <LogIn className="h-4 w-4" /> Accedi
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
